import React from 'react';

import styles from '../title.module.scss';
import { ReactComponent as Legislation } from '../../../../icons/entities/law.svg';

export const LegislationIcon = <Legislation className={styles.icon} />;
